// extracted by mini-css-extract-plugin
export default {"container":"nav_container__d3uO-","container2":"nav_container2__rf3j4","iconContainer":"nav_iconContainer__wmXqG","h2":"nav_h2__+5pVG","activeLink":"nav_activeLink__nJ-Ti"};